import commonPostTypeConfig from '../../common/postTypes/chat'

export default function initPostType({ wapp }) {
    return wapp.client.postTypes.getPostType({
        name: 'chat',
        addIfThereIsNot: true,
        statusManager: commonPostTypeConfig.getStatusManager()
    })
}
